import { render, staticRenderFns } from "./Holder.vue?vue&type=template&id=29aa710e&scoped=true&"
import script from "./Holder.vue?vue&type=script&lang=js&"
export * from "./Holder.vue?vue&type=script&lang=js&"
import style0 from "./Holder.vue?vue&type=style&index=0&id=29aa710e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa710e",
  null
  
)

export default component.exports